import React, { useEffect, useState } from 'react';
import { scrollToId } from './constants';

const LINKS = [
  ['metodo', 'Método'],
  ['sobre', 'Sobre'],
  ['setores', 'Setores'],
  ['duvidas', 'Dúvidas'],
];

export const BrandHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, []);

  return (
    <header
      data-testid="brand-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,padding] duration-500 border-b ${scrolled ? 'bg-[#0A0D10]/80 backdrop-blur-xl border-white/10 py-3' : 'bg-transparent border-transparent py-5'}`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 flex items-center justify-between gap-6">
        <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-left leading-none" data-testid="brand-logo">
          <span className="br-serif block text-xl sm:text-2xl font-semibold">Anderson Coutinho</span>
          <span className="br-mono block text-[9px] sm:text-[10px] text-[var(--br-teal)] mt-1.5">◆ Estrategista de Marca</span>
        </button>
        <nav className="hidden lg:flex items-center gap-9 text-sm text-[var(--br-muted)]">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => scrollToId(id)} className="hover:text-white transition-colors" data-testid={`nav-${id}`}>{label}</button>
          ))}
        </nav>
        <button
          onClick={() => scrollToId('raio-x')}
          data-testid="header-raio-x-cta"
          className="rounded-full bg-[var(--br-teal)] text-black text-xs sm:text-sm font-bold px-4 sm:px-6 py-2.5 sm:py-3 transition-[transform,background-color] duration-300 hover:bg-white hover:-translate-y-0.5"
        >
          Raio-X grátis
        </button>
      </div>
    </header>
  );
};
